var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageTitle',{staticClass:"strech",attrs:{"title":_vm.textosTeatro.t('renovar_abono.titulo', { temporada: _vm.lista_abonados.nombre, abono: _vm.teatro.texto_abono })}}),(! _vm.isLfp)?[_c('RenovarAbono')]:[_c('RenovarAbonoLfp')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }